import { Link, useLocation } from "@tanstack/react-router";
import { useLocale, localeHref, stripLocale, type Locale } from "@/lib/i18n";

export function LangSwitcher({ className, onDark }: { className?: string; onDark?: boolean }) {
  const current = useLocale();
  const { pathname } = useLocation();
  const basePath = stripLocale(pathname);

  const renderLink = (target: Locale, label: string) => {
    const href = localeHref(target, basePath);
    const active = target === current;
    const inactive = onDark
      ? "text-background/80 hover:text-amber-glass"
      : "text-muted-foreground hover:text-terracotta";
    const activeCls = onDark ? "text-background" : "text-foreground";
    return (
      <Link
        to={href}
        hrefLang={target}
        aria-current={active ? "true" : undefined}
        className={`px-1.5 py-0.5 text-[10px] uppercase tracking-[0.22em] transition-colors ${
          active ? activeCls : inactive
        }`}
      >
        {label}
      </Link>
    );
  };

  return (
    <div
      className={`inline-flex items-center gap-0.5 ${className ?? ""}`}
      role="group"
      aria-label="Language"
    >
      {renderLink("da", "DA")}
      <span className="text-muted-foreground" aria-hidden="true">/</span>
      {renderLink("en", "EN")}
    </div>
  );
}
